<template>
  <div>
    <!--面包屑-->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/Home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>关于表单</el-breadcrumb-item>
      <el-breadcrumb-item>委员申请</el-breadcrumb-item>
    </el-breadcrumb>

    <!--卡片区域-->
    <el-card class="box-card">
      <el-row :gutter="20" type="flex" align="middle">
        <el-col>
          <el-form :inline="true" class="searchDiv">
            <el-form-item label="关键词">
              <el-input
                  clearable
                  placeholder="搜索关键词"
                  v-model="searchKey"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="4">
          <el-button size="mini" round type="success" @click="onSubmit"
          >搜索
          </el-button
          >
        </el-col>
        <el-col :span="4">
          <el-button size="mini" round type="warning" @click="onAdd"
          >新增
          </el-button
          >
        </el-col>
      </el-row>
      <!--用户列表区 -->
      <div class="table">
        <el-table
            :data="tableData"
            :border="true"
            :height="getH()"
            v-loading.body="isLoading"
            stripe
            :resizable="true"
        >
          <el-table-column
              show-overflow-tooltip
              v-for="(item, index) in propList"
              :key="index"
              :prop="item.prop"
              :label="item.label"
              :width="item.width ? item.width : 100"
          >
            <template slot-scope="scope">
              <div v-if="item.type == 'array'">
                {{ getOptionVal(item.data, scope.row[item.prop]) }}
              </div>
              <div v-else-if="item.type == 'html'" v-html="scope.row[item.prop]">

              </div>
              <!--显示图-->
              <div
                  v-else-if="
                  item.type  == 'pic' "
              >
                <el-image
                    v-if="scope.row[scope.column['property']]"
                    :src="$getUrl(scope.row[scope.column['property']])"
                    fit="scale-down"
                    style="height: 100px"
                />
              </div>

              <div class="show-btn" v-else-if=" item.type =='showHtml' && scope.row[scope.column['property']]">
                <el-button type="success" @click="$showHtml(scope.row[scope.column['property']])">查看</el-button>
              </div>

              <div v-else>
                {{ scope.row[scope.column["property"]] }}
              </div>

            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="250">
            <template slot-scope="scope">
              <div class="caoz">
                <el-button
                    type="text"
                    size="small"
                    @click="onEditItem(scope.row)"
                >编辑
                </el-button
                >
                <el-button
                    type="text"
                    size="small"
                    @click="onDelItem(scope.row)"
                >
                  删除
                </el-button
                >

                <el-button
                    type="info"
                    size="small"
                    round
                    @click="onDownWord(scope.row)"
                >
                  下载表格
                </el-button
                >

              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页区-->
      <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      >
      </el-pagination>
    </el-card>

    <!--编辑窗口-->
    <el-dialog
        v-if="showEditDlg"
        :close-on-click-modal="false"
        :title="!editItem.id ? '新增' : '编辑'"
        :visible.sync="showEditDlg"
        width="300"
        :before-close="handleCloseDlg"
    >
      <el-form :inline="false" label-width="150px">
        <el-row>
          <el-col
              class="myElCol"
              :span="11"
              v-for="(item, index) in propList"
              :key="index"
          >
            <el-form-item :label="item.label">
              <el-select
                  v-if="item.type == 'array'"
                  v-model="editItem[item.prop]"
                  placeholder="请选择"
              >
                <el-option
                    v-for="(item2, index2) in item.data"
                    :key="index2"
                    :label="item2"
                    :value="index2"
                >
                </el-option>
              </el-select>

              <el-select
                  v-else-if="item.type == 'arrayObj'"
                  v-model="editItem[item.prop]"
                  placeholder="请选择"
              >
                <el-option
                    v-for="(item2, index2) in item.data"
                    :key="index2"
                    :label="item2.title"
                    :value="item2.val"
                >
                </el-option>
              </el-select>


              <el-select
                  v-else-if="item.type == 'list'"
                  v-model="editItem[item.prop]"
                  placeholder="请选择"
              >
                <el-option
                    v-for="(item2, index2) in item.data"
                    :key="index2"
                    :label="item2"
                    :value="item2"
                >
                </el-option>
              </el-select>

              <el-date-picker
                  v-else-if="item.type == 'time'"
                  v-model="editItem[item.prop]"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间"
              >
              </el-date-picker>
              <el-input
                  v-else
                  :type="item.type == 'textarea'
                  || item.type == 'showHtml'
                   || item.type == 'pic'
                    || item.type == 'video'
                  ? 'textarea' : 'text'"
                  :disabled="item.prop == 'id'"
                  :rows="2"
                  clearable
                  v-model="editItem[item.prop]"
              >
              </el-input>
              <el-button style="margin-top: 5px;" v-if="item.type == 'showHtml'" type="primary"
                         @click="$copy(editItem[item.prop])">复制代码
              </el-button>

              <MyUploadPlus
                  v-if="
                  item.type == 'pic' ||  item.type == 'video' "
                  accept="*"
                  :disabled="false"
                  @urlChange="(e) => onUrlChange(item.prop, e)"
              />

            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showEditDlg = false">取 消</el-button>
        <el-button type="primary" @click="onSaveEdit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>


<script>


export default {
  data() {
    return {
      isLoading: false,
      //当前的页数
      page: 1,
      //当前的页码显示的条数
      pageSize: 10,
      //最后页号
      last_page: 0,

      searchKey: "",
      cate_id: "",
      kc_id: "",
      has_cert: "",
      class_type: "",

      //用户数据列表 默认为空
      tableData: [],
      //总数据条数
      total: 0,
      /**
       *
       `id` int(11) NOT NULL AUTO_INCREMENT,
       `add_time` timestamp NOT NULL DEFAULT CURRENT_TIMESTAMP COMMENT '添加时间',
       `add_ip` varchar(255) NOT NULL DEFAULT '' COMMENT '添加IP',
       `name` varchar(255) NOT NULL DEFAULT '' COMMENT '姓名',
       `sex` varchar(255) NOT NULL DEFAULT '' COMMENT '性别',
       `minzu` varchar(255) NOT NULL DEFAULT '' COMMENT '民族',
       `mianmiao` varchar(255) NOT NULL DEFAULT '' COMMENT '政治面貌',
       `company` varchar(255) NOT NULL DEFAULT '' COMMENT '单位',
       `job` varchar(255) NOT NULL DEFAULT '' COMMENT '职务',
       `xueli` varchar(255) NOT NULL DEFAULT '' COMMENT '学历',
       `rank` varchar(255) NOT NULL DEFAULT '' COMMENT '职称',
       `birthday` varchar(255) NOT NULL DEFAULT '' COMMENT '出生年月',
       `address` varchar(255) NOT NULL DEFAULT '' COMMENT '通讯地址',
       `idcard` varchar(255) NOT NULL DEFAULT '' COMMENT '身份证号',
       `yisizigezheng` varchar(255) NOT NULL DEFAULT '' COMMENT '医生资格证号',
       `phone` varchar(255) NOT NULL DEFAULT '' COMMENT '手机',
       `postcode` varchar(255) NOT NULL DEFAULT '' COMMENT '邮编',
       `wx` varchar(255) NOT NULL DEFAULT '' COMMENT '微信号',
       `desc` text COMMENT '个人简历',
       `bz` varchar(255) NOT NULL DEFAULT '' COMMENT '备注',
       *
       */
      propList: [
        {
          prop: "id",
          label: "ID",
          width: 80,
        },
        {
          prop: "add_time",
          label: "添加时间",
          type: 'time',
          width: 200,
        },
        {
          prop: "add_ip",
          label: "添加IP",
          width: 200,
        },
        {
          prop: "name",
          label: "姓名",
        },
        {
          prop: "sex",
          label: "性别",
        },
        {
          prop: "minzu",
          label: "民族",
        },
        {
          prop: "mianmiao",
          label: "政治面貌",
        },
        {
          prop: "company",
          label: "单位",
        },
        {
          prop: "job",
          label: "职务",
        },
        {
          prop: "xueli",
          label: "学历",
        },
        {
          prop: "rank",
          label: "职称",
        },

        {
          prop: "birthday",
          label: "出生年月",
          width: 200,
          type: 'time',
        },
        {
          prop: "address",
          label: "通讯地址",
        },

        {
          prop: "idcard",
          label: "身份证号",
        },
        {
          prop: "yisizigezheng",
          label: "医生资格证号",
          width: 150
        },
        {
          prop: "phone",
          label: "手机",
        },
        {
          prop: "postcode",
          label: "邮编",
        },

        {
          prop: "wx",
          label: "微信号",
        },
        {
          prop: "desc",
          label: "个人简历",
          type: 'textarea',
          width: 200
        },
        {
          prop: "bz",
          label: "备注",
        },

      ],
      //当前编辑项目内容
      editItem: {},
      //显示编辑窗口
      showEditDlg: false,
      //所有权限列表
      powerList: [],
    };
  },
  created() {
    //窗体大小变化就执行getH方法
    window.addEventListener("resize", this.getH);

    this.getList();
  },

  methods: {
    //调整table 高度
    getH() {
      return window.innerHeight - 320;
    },
    handleCloseDlg() {
      console.log("handleCloseDlg");
      this.showEditDlg = false;
    },

    //获取列表
    async getList() {
      let obj = {
        page: this.page,
        pageSize: this.pageSize,
        searchKey: this.searchKey,

      };
      const res = await this.$post(`AboutApplyFor/getList`, obj);
      console.log(res);
      if (res.code !== 200) return;

      this.tableData = res.data.data;

      this.total = res.data.total;
    },

    //监听 pagesize 改变的事件
    handleSizeChange(newSize) {
      //console.log(newSize)
      this.pageSize = newSize;
      this.getList();
    },

    //监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      //console.log(newPage)
      this.page = newPage;
      //获取用户列表数据
      this.getList();
    },
    //点击搜索显示搜索内容
    onSubmit() {
      this.page = 1
      this.getList();
    },
    // 展示编辑角色对话框 Dialog:对话框
    onEditItem(item) {
      this.editItem = JSON.parse(JSON.stringify(item));

      this.showEditDlg = true;
    },

    onAdd() {
      console.log("onAdd");
      let obj = {};
      for (let i in this.propList) {
        let prop = this.propList[i]["prop"];
        this.$set(obj, prop, "");
      }
      this.editItem = obj;
      this.showEditDlg = true;
    },
    //点击确定保存信息
    async onSaveEdit() {
      let obj = {
        id: this.editItem.id,
        data: this.editItem,
      };


      //处理html代码
      obj.data['desc'] = this.base64EnCode(obj.data['desc'])

      const res = await this.$post(`AboutApplyFor/saveData`, obj);
      console.log(res);
      this.showEditDlg = false;
      if (res.code !== 200) return;
      this.$ok(res.msg);
      this.getList();
    },
    //点击删除弹出对话框是否真的删除
    async onDelItem(item) {
      //弹出对话框是否真的删除 此操作将永久删除该信息
      const confirmResult = await this.$confirm(
          "此操作将永久删除该信息?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
      ).catch((err) => err);
      //如果用户确认删除,则返回值为字符串  confirm
      //如果用户取消删除,则返回值为字符串  cancel
      //console.log( confirmResult );
      if (confirmResult !== "confirm") {
        return this.$info("已取消删除");
      }
      let obj = {
        id: item.id,
      };
      console.log(obj);
      const res = await this.$post(`AboutApplyFor/delItem`, obj);
      console.log("确认删除", res);
      if (res.code !== 200) return;
      this.$ok(res.msg);
      this.getList();
    },
    onUrlChange(fielddName, e) {
      console.log("获取 getUrlChange", fielddName, e);
      this.editItem[fielddName] = e[0].url;
    },
    //下载word
    async onDownWord(row) {
      this.isLoading = true
      const {code, msg, data} = await this.$post(`AboutApplyFor/downWord`, {
        id: row.id
      });
      console.log("下载返回", msg);

      this.isLoading = false
      if (code != 200) return

      let url = this.$imgUrl + data
      window.open(url)

    }
  },
};
</script>

<style lang="less" scoped>
.mybtn {
  display: flex;
  justify-content: flex-end;
}

.jifen {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
}

.show-btn {
  display: flex;
  justify-content: center;
}
</style>
